import {
  RESET_AUTH, PURGE_AUTH, SET_TOKEN, UPDATE_SHIFT, START_DAY,
} from '../mutation-types';
import AuthService from '@/services/AuthService';
import DayService from '@/services/DayService';
import router from '@/router';
// state
const localState = () => ({
  userId: localStorage.getItem('pos_userId') || '',
  token: localStorage.getItem('pos_token') || '',
  stations: JSON.parse(localStorage.getItem('pos_stations') || '{}'),
  locations: JSON.parse(localStorage.getItem('pos_locations') || '{}'),
  user: JSON.parse(localStorage.getItem('pos_user') || '{}'),
  currency: JSON.parse(localStorage.getItem('pos_currency') || '{"id":101,"name":"Baht","symbol":"฿","exchangeRate":null,"code":"THB","coin":["0.25","0.5","1","5","10"],"bill":["20","50","100","500","1000"],"createdDate":"2020-03-06 08:35:44","updatedDate":"2020-03-06 08:35:44","decimalType":false,"deletedAt":null}'),
});

// mutations
const mutations = {
  setLocation(state, item) {
    if (state.locations) {
      Object.keys(state.locations).forEach((key) => {
        if (key === item.id) {
          state.locations[key] = item;
        }
      });
      localStorage.setItem('pos_locations', JSON.stringify(state.locations));
    }
    if (state.user && state.user.location) {
      state.user.location = item;
      localStorage.setItem('pos_user', JSON.stringify(state.user));
    }
  },
  [RESET_AUTH](state) {
    Object.assign(state, localState());
  },

  [PURGE_AUTH](state) {
    state.userId = '';
    state.token = '';
    state.user = {};
    state.stations = {};
    state.locations = {};
    localStorage.removeItem('pos_userId');
    localStorage.removeItem('pos_token');
    localStorage.removeItem('pos_stations');
    localStorage.removeItem('pos_locations');
    localStorage.removeItem('pos_user');
    localStorage.removeItem('lang');
    localStorage.removeItem('pos_currency');
  },

  [SET_TOKEN](state, {
    user, stations, locations, lang, token, currency,
  }) {
    state.userId = user.id;
    state.token = token;
    state.user = user;
    state.currency = currency || {};
    const stationMap = {};
    stations.forEach((station) => {
      stationMap[station.id] = station;
    });
    state.stations = stationMap;
    const locationMap = {};
    locations.forEach((location) => {
      locationMap[location.id] = location;
    });
    state.locations = locationMap;
    localStorage.setItem('pos_userId', state.userId);
    localStorage.setItem('pos_token', state.token);
    localStorage.setItem('pos_user', JSON.stringify(state.user));
    localStorage.setItem('pos_stations', JSON.stringify(state.stations));
    localStorage.setItem('pos_locations', JSON.stringify(state.locations));
    localStorage.setItem('lang', lang);
    localStorage.setItem('pos_currency', JSON.stringify(state.currency));
  },

  async [START_DAY](state) {
    const workDay = await DayService.startDay();
    if (workDay) {
      state.user.workDay = workDay;
      localStorage.setItem('pos_user', JSON.stringify(state.user));
      return true;
    }
    return false;
  },

  [UPDATE_SHIFT](state, shift) {
    state.user.shift = shift;
    localStorage.setItem('pos_user', JSON.stringify(state.user));
  },

};

// actions
const actions = {
  async logout({ commit, getters, dispatch }) {
    const response = await AuthService.pickStation(0);
    if (response) {
      dispatch('resetBill');
      commit(PURGE_AUTH);
      router.push({ name: 'login' });
      window.location.reload();
    }
  },
};

export default {
  state: localState(),
  mutations,
  actions,
};
